module.exports = "<div md-dialog-title>Cancelar</div>\r\n<div md-dialog-content>¿Deseas cancelar la solicitud de inscripción?</div>\r\n<div md-dialog-actions>\r\n  <button md-button md-raised-button color=\"primary\" md-dialog-close=\"Yes\">Sí</button>\r\n  <button md-button md-raised-button md-dialog-close=\"No\">No</button>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/cancel-application/cancel-application.component.html
// module id = ../../../../../src/app/components/cancel-application/cancel-application.component.html
// module chunks = main